export const RESOURCE_CURSOR_LIMIT = 10000;
